import {NumberInput} from '@mantine/core';
import {renderFieldLabel} from 'src/app/forms/renderFieldLabel';
import React from 'react';
import type {IFormFieldV2} from 'src/types/FormV2';

export interface FormNumberV2Props {
  field: IFormFieldV2;
  value: number | '';
  error?: string;
  onChange: (name: string, value: number | undefined) => void;
}

export const FormNumberV2 = React.memo<FormNumberV2Props>(
  ({field, value, error, onChange}: FormNumberV2Props) => {
    const currencyProps =
      field.numberOptions?.format === 'currency'
        ? {
            prefix: '$',
            decimalScale: 2,
            fixedDecimalScale: true,
            thousandSeparator: ',',
            hideControls: true,
          }
        : {};
    return (
      <NumberInput
        data-testid={`form-field-${field.name}`}
        label={renderFieldLabel(field)}
        description={field.description}
        error={error}
        value={value}
        onChange={val =>
          onChange(field.name, typeof val === 'number' ? val : undefined)
        }
        min={field.validation?.min}
        max={field.validation?.max}
        withAsterisk={field.required}
        placeholder={`Enter ${field.label.toLowerCase()}`}
        disabled={field.disabled}
        {...currencyProps}
      />
    );
  }
);
